module.exports = __webpack_public_path__ + "static/media/18@2x.f9c18b28.png";